import { getApi } from '../../../api/api'
import endpoints from '../../../config/endpoints'
import type { Tenant } from '../../../types/tenant'

export const tenantProfileApi = {
  get: function (
    id: number | string | undefined | null,
    params?: {
      search?: string
    }
  ): Promise<Tenant> {
    return getApi<Tenant>({
      endpoint: endpoints.tenants(id),
      params,
    })
  },
}
